import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={19}
    height={19}
    fill="none"
    {...props}
  >
    <path
      fill="#fff"
      d="M9.557 11.028v1.463a4.39 4.39 0 0 0-4.39 4.39H3.703a5.854 5.854 0 0 1 5.854-5.853Zm0-.732a4.389 4.389 0 0 1-4.39-4.39 4.389 4.389 0 0 1 4.39-4.39 4.389 4.389 0 0 1 4.39 4.39 4.389 4.389 0 0 1-4.39 4.39Zm0-1.463a2.926 2.926 0 1 0 0-5.854 2.926 2.926 0 1 0 0 5.854Zm1.898 5.715a2.564 2.564 0 0 1 0-1.187l-.725-.419.731-1.267.726.419a2.56 2.56 0 0 1 1.028-.594v-.838h1.464v.838c.39.116.74.322 1.028.594l.726-.42.732 1.268-.726.419a2.57 2.57 0 0 1 0 1.187l.726.42-.732 1.267-.726-.42a2.557 2.557 0 0 1-1.028.595v.837h-1.464v-.837a2.557 2.557 0 0 1-1.027-.595l-.727.42-.731-1.268.725-.419Zm2.492.504a1.098 1.098 0 1 0 0-2.195 1.098 1.098 0 0 0 0 2.195Z"
    />
  </svg>
)
export default SvgComponent
